<div class="bg-image flex-grow-1">
  <header class="mb-3 mb-lg-5 shadow bg-light bg-opacity-50">
    <div class="py-4 container-lg">
      <h4>Търсене на артикули</h4>
      <nz-search-input
        [searchValue]="searchValue"
        (onSearchValueChange)="onSearch($event)"
        placeholder="Търсене по заглавие...">
      </nz-search-input>
    </div>
  </header>
  <section class="mb-5 container-lg">
    <div class="row g-0 g-lg-4">
      <aside class="col-12 col-lg-4 col-xl-3">
        @if (!!sellerUsername) {
          <div class="d-block d-lg-none">
            <ng-container [ngTemplateOutlet]="alertSeller"/>
          </div>
        }
        <nz-sidebar-menu
          title="Категории"
          [items]="categoryMenuItems"
          [selectedItem]="selectedCategoryMenuItem"/>
        @if (this.subcategoryMenuItems.length !== 0) {
          <div class="mt-3 mt-lg-0">
            <nz-sidebar-menu
              title="Подкатегории"
              [items]="subcategoryMenuItems"
              [selectedItem]="selectedSubcategoryMenuItem"/>
          </div>
        }
      </aside>
      <main class="col-12 col-lg-8 col-xl-9">
        @if (!!sellerUsername) {
          <div class="mb-4 d-none d-lg-block">
            <ng-container [ngTemplateOutlet]="alertSeller"/>
          </div>
        }
        <nz-ad-list-filter/>
        <div class="mb-4 mt-4 mt-lg-0">
          <nz-search-result
            [totalResults]="this.totalResults"
            [sortOptions]="sortOptions"
            [selectedSortOption]="selectedSortOption"
            (onSortOptionChange)="onSort($event)">
          </nz-search-result>
        </div>
        @if (!loading) {
          @if (filteredAds.length === 0) {
            <h4 class="my-5 text-center text-muted">
              Няма намерени обяви
            </h4>
          }
          <div class="row g-4" nzRestoreScrollPosition>
            @for (ad of filteredAds; track ad.adId) {
              <div class="col-12 col-sm-6 col-xl-4">
                <nz-ad-card [data]="ad"/>
              </div>
            }
          </div>
        } @else {
          <section class="my-5">
            <div class="text-center">
              <h1>
                <i class="text-dark fa-solid fa-spinner fa-spin"></i>
              </h1>
              <h5 class="text-muted">Зареждане...</h5>
            </div>
          </section>
        }
        @if (this.totalResults > defaultPageLimit) {
          <section class="mt-5">
            <nz-pagination
              [totalResults]="totalResults"
              [selectedPage]="selectedPage"
              [selectedPageLimitOptionId]="selectedPageLimitOptionId"/>
          </section>
        }
      </main>
    </div>
  </section>
</div>
<ng-template #alertSeller>
  <div class="alert alert-primary d-flex align-items-center justify-content-between">
    <span>Обяви на <strong>{{ sellerUsername }}</strong>.</span>
    <a class="btn btn-nz-primary btn-sm"
       aria-label="Изчисти"
       queryParamsHandling="merge"
       [routerLink]="currentRoute"
       [queryParams]="{sellerId: null, sellerUsername: null}">
      <i class="m-1 small fa-solid fa-x"></i>
      <span class="ms-1 d-none d-lg-inline-block">Изчисти</span>
    </a>
  </div>
</ng-template>
